import React from "react";
import { formatCurrency } from "../../../../utils/moneyFormat";
import { transalateTransactionStatus } from "../../../../translates/transactions/transactions";
import { PaymentDetailField } from "./PaymentDetailField";
import { PaymentDetailProps } from "../interfaces";

const statusStyles: Record<number, string> = {
  0: "bg-red-100 text-red-700",
  1: "bg-green-100 text-green-700",
  2: "bg-yellow-100 text-yellow-700",
  3: "bg-orange-100 text-orange-700",
  4: "bg-blue-100 text-blue-700",
  5: "bg-gray-100 text-gray-700",
  8: "bg-yellow-100 text-yellow-700",
};

export const PaymentDetail: React.FC<PaymentDetailProps> = ({
  code,
  fields,
  title,
  total,
  status,
}) => {
  const statusLabel = transalateTransactionStatus[status] || "Desconocido";
  const statusClass = statusStyles[status] || "bg-gray-100 text-gray-700";

  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 border-b border-gray-200 p-4">
        <div className="flex items-center gap-2">
          <h3 className="text-base font-medium text-gray-800">
            {title}
            <span className="ml-2 text-sm font-normal text-gray-400">{code}</span>
          </h3>
          <span className={`rounded-full px-2.5 py-0.5 text-xs font-medium ${statusClass}`}>
            {statusLabel}
          </span>
        </div>
        <p className="font-medium text-primary">{formatCurrency(total)}</p>
      </div>
      <div className="grid gap-x-6 gap-y-4 p-4 md:grid-cols-2">
        <div className="space-y-4">
          {fields.left
            .filter((field) => !(field.isConditional && !field.value))
            .map((field) => (
              <PaymentDetailField
                key={field.label}
                info={field.info}
                isCopyable={field.isCopyable}
                label={field.label}
                type={field.type}
                value={field.value}
              />
            ))}
        </div>
        <div className="space-y-4">
          {fields.right
            .filter((field) => !(field.isConditional && !field.value))
            .map((field) => (
              <PaymentDetailField
                key={field.label}
                info={field.info}
                isCopyable={field.isCopyable}
                label={field.label}
                type={field.type}
                value={field.value}
              />
            ))}
        </div>
      </div>
    </>
  );
};
